import React from 'react';
import { Card, CardContent } from './ui/card';
import { Badge } from './ui/badge';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../translations/translations';

export const Products = () => {
  const { language } = useLanguage();
  const t = translations[language];

  const products = [
    {
      id: 1,
      name: t.freshStrawberries,
      description: t.strawberriesDesc,
      image: "https://customer-assets.emergentagent.com/job_e89f86fd-ccbb-428c-8bc5-5519914e6241/artifacts/ilsmaupt_WhatsApp%20Image%202025-12-09%20at%2017.33.16_247ae2f4.jpg",
      category: t.berries,
      altText: language === 'ar' ? 'فراولة طازجة ممتازة من شركة الحنادس - استيراد فواكه العراق' : 'Premium fresh strawberries from AL HANADIS COMPANY - Iraq fruit import'
    },
    {
      id: 2,
      name: t.goldenApples,
      description: t.goldenApplesDesc,
      image: "https://customer-assets.emergentagent.com/job_e89f86fd-ccbb-428c-8bc5-5519914e6241/artifacts/iitzj2x3_WhatsApp%20Image%202025-12-09%20at%2017.33.49_c7627611.jpg",
      category: t.apples,
      altText: language === 'ar' ? 'تفاح ذهبي عالي الجودة من شركة الحنادس - زاخو العراق' : 'High quality golden apples from AL HANADIS COMPANY - Zakho Iraq'
    },
    {
      id: 3,
      name: t.peachesApricots,
      description: t.peachesDesc,
      image: "https://customer-assets.emergentagent.com/job_e89f86fd-ccbb-428c-8bc5-5519914e6241/artifacts/oz608s7r_WhatsApp%20Image%202025-12-09%20at%2017.34.02_40087839.jpg",
      category: t.stoneFruits,
      altText: language === 'ar' ? 'خوخ ومشمش طازج من شركة الحنادس - فواكه مستوردة العراق' : 'Fresh peaches and apricots from AL HANADIS COMPANY - imported fruits Iraq'
    },
    {
      id: 4,
      name: t.redApples,
      description: t.redApplesDesc,
      image: "https://customer-assets.emergentagent.com/job_e89f86fd-ccbb-428c-8bc5-5519914e6241/artifacts/5osl506b_WhatsApp%20Image%202025-12-10%20at%204.01.26%20PM.jpeg",
      category: t.apples,
      altText: language === 'ar' ? 'تفاح أحمر ممتاز من شركة الحنادس - أفضل فواكه العراق' : 'Premium red apples from AL HANADIS COMPANY - best fruits Iraq'
    },
    {
      id: 5,
      name: t.greenGrapes,
      description: t.grapesDesc,
      image: "https://customer-assets.emergentagent.com/job_e89f86fd-ccbb-428c-8bc5-5519914e6241/artifacts/05g8unnr_WhatsApp%20Image%202025-12-10%20at%204.01.27%20PM%20%281%29.jpeg",
      category: t.grapes,
      altText: language === 'ar' ? 'عنب أخضر طازج من شركة الحنادس - فواكه طازجة زاخو' : 'Fresh green grapes from AL HANADIS COMPANY - fresh fruits Zakho'
    },
    {
      id: 6,
      name: t.premiumMangoes,
      description: t.premiumMangoesDesc,
      image: "https://customer-assets.emergentagent.com/job_e89f86fd-ccbb-428c-8bc5-5519914e6241/artifacts/x5v45zho_WhatsApp%20Image%202025-12-10%20at%204.01.27%20PM%20%282%29.jpeg",
      category: language === 'ar' ? 'مانجو' : 'Mangoes',
      altText: language === 'ar' ? 'مانجو ذهبي ممتاز من شركة الحنادس - استيراد فواكه العراق' : 'Premium golden mangoes from AL HANADIS COMPANY - Iraq fruit import'
    }
  ];

  return (
    <section id="products" className="py-20 lg:py-32 bg-amber-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-800 mb-6">
            {t.productsTitle}
          </h2>
          <div className="w-24 h-1 bg-orange-500 mx-auto mb-8"></div>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            {t.productsDescription}
          </p>
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {products.map((product) => (
            <Card
              key={product.id}
              className="overflow-hidden border-none shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 bg-white"
            >
              {/* Product Image */}
              <div className="relative overflow-hidden aspect-square">
                <img
                  src={product.image}
                  alt={product.altText}
                  className="w-full h-full object-cover transition-transform duration-500 hover:scale-110"
                />
                <div className="absolute top-4 right-4">
                  <Badge className="bg-orange-500 text-white hover:bg-orange-600 border-none shadow-md">
                    {product.category}
                  </Badge>
                </div>
              </div>

              {/* Product Info */}
              <CardContent className="p-6">
                <h3 className="text-xl font-bold text-gray-800 mb-3">
                  {product.name}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {product.description}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Additional Info */}
        <div className="mt-16 text-center">
          <div className="bg-white rounded-lg p-8 shadow-md max-w-4xl mx-auto">
            <h3 className="text-2xl font-bold text-gray-800 mb-4">
              {t.seasonalSelection}
            </h3>
            <p className="text-gray-600 leading-relaxed">
              {t.seasonalInfo}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
